import { useEffect, useState } from "react";

export const useColourScheme = () => {
  const darkSchemeQuery = window.matchMedia("(prefers-color-scheme: dark)");
  const [isDarkScheme, setIsDarkScheme] = useState(darkSchemeQuery.matches);

  useEffect(() => {
    const onChange = (event: MediaQueryListEvent) => {
      setIsDarkScheme(event.matches);
    };

    darkSchemeQuery.addEventListener("change", onChange);

    return () => {
      darkSchemeQuery.removeEventListener("change", onChange);
    };
  }, []);

  return {
    isDarkScheme,
  };
};
